import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../../styles/midnight-lab.css';

function DashboardHome() {
  const [stats] = useState({
    overdueTasks: 3,
    dueThisWeek: 8,
    lowInventory: 5,
    upcomingEvents: 2
  });

  const quickActions = [
    { label: 'New Task', path: '/dashboard/tasks?new=true', color: 'var(--color-frozen-lake)' },
    { label: 'Add Item', path: '/dashboard/inventory?new=true', color: 'var(--color-yellow-green)' },
    { label: 'New Event', path: '/dashboard/calendar?new=true', color: 'var(--color-frozen-lake)' }
  ];

  const recentItems = [
    { type: 'task', title: 'Order REV motors', status: 'overdue', time: '2 days ago' },
    { type: 'inventory', title: 'Mecanum wheels - Low stock', status: 'warning', time: '1 hour ago' },
    { type: 'task', title: 'Update robot CAD', status: 'due-soon', time: '5 hours ago' }
  ];

  return (
    <div>
      {/* Header */}
      <div style={{
        marginBottom: 'var(--space-8)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 'var(--space-4)'
      }}>
        <div>
          <h1 style={{
            fontFamily: 'var(--font-sans)',
            fontSize: 'clamp(2rem, 4vw, 3rem)',
            fontWeight: 700,
            color: 'var(--color-text-primary)',
            marginBottom: 'var(--space-2)',
            letterSpacing: '-0.02em'
          }}>
            Dashboard
          </h1>
          <p style={{
            fontFamily: 'var(--font-sans)',
            fontSize: 'var(--text-base)',
            color: 'var(--color-text-secondary)'
          }}>
            Overview of tasks, inventory, and upcoming events
          </p>
        </div>
        <div style={{
          display: 'flex',
          gap: 'var(--space-2)',
          flexWrap: 'wrap'
        }}>
          {quickActions.map((action, index) => (
            <Link
              key={index}
              to={action.path}
              style={{
                padding: 'var(--space-3) var(--space-6)',
                backgroundColor: action.color,
                color: 'var(--color-text-primary)',
                fontFamily: 'var(--font-sans)',
                fontSize: 'var(--text-sm)',
                fontWeight: 600,
                textDecoration: 'none',
                borderRadius: '6px',
                transition: 'all var(--transition-base)',
                display: 'flex',
                alignItems: 'center',
                gap: 'var(--space-2)'
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.opacity = '0.9';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.opacity = '1';
              }}
            >
              <span>+</span>
              {action.label}
            </Link>
          ))}
        </div>
      </div>

      {/* Stats Cards */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: 'var(--space-6)',
        marginBottom: 'var(--space-8)'
      }}>
        <StatCard
          title="Overdue Tasks"
          value={stats.overdueTasks}
          color="var(--color-yellow-green)"
          link="/dashboard/tasks?filter=overdue"
        />
        <StatCard
          title="Due This Week"
          value={stats.dueThisWeek}
          color="var(--color-frozen-lake)"
          link="/dashboard/tasks?filter=this-week"
        />
        <StatCard
          title="Low Inventory"
          value={stats.lowInventory}
          color="var(--color-yellow-green)"
          link="/dashboard/inventory?filter=low-stock"
        />
        <StatCard
          title="Upcoming Events"
          value={stats.upcomingEvents}
          color="var(--color-frozen-lake)"
          link="/dashboard/calendar"
        />
      </div>

      {/* Recent Activity */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
        gap: 'var(--space-6)'
      }}>
        <Card title="Recent Activity">
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 'var(--space-4)'
          }}>
            {recentItems.map((item, index) => (
              <div
                key={index}
                style={{
                  padding: 'var(--space-4)',
                  borderBottom: '1px solid rgba(0, 16, 17, 0.1)',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                <div>
                  <div style={{
                    fontFamily: 'var(--font-sans)',
                    fontSize: 'var(--text-base)',
                    fontWeight: 600,
                    color: 'var(--color-text-primary)',
                    marginBottom: 'var(--space-1)'
                  }}>
                    {item.title}
                  </div>
                  <div style={{
                    fontFamily: 'var(--font-sans)',
                    fontSize: 'var(--text-xs)',
                    color: 'var(--color-text-secondary)'
                  }}>
                    {item.time}
                  </div>
                </div>
                <div style={{
                  padding: 'var(--space-1) var(--space-3)',
                  backgroundColor: getStatusColor(item.status),
                  color: 'var(--color-text-primary)',
                  fontFamily: 'var(--font-sans)',
                  fontSize: 'var(--text-xs)',
                  fontWeight: 600,
                  textTransform: 'uppercase',
                  borderRadius: '4px'
                }}>
                  {item.status.replace('-', ' ')}
                </div>
              </div>
            ))}
          </div>
        </Card>

        <Card title="Quick Links">
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 'var(--space-3)'
          }}>
            <Link to="/dashboard/inventory" style={linkStyle}>View All Inventory</Link>
            <Link to="/dashboard/tasks" style={linkStyle}>All Tasks</Link>
            <Link to="/dashboard/calendar" style={linkStyle}>Calendar View</Link>
            <Link to="/dashboard/roles" style={linkStyle}>Team Members</Link>
          </div>
        </Card>
      </div>
    </div>
  );
}

function StatCard({ title, value, color, link }) {
  return (
    <Link
      to={link}
      style={{
        padding: 'var(--space-6)',
        borderBottom: '2px solid rgba(0, 16, 17, 0.1)',
        textDecoration: 'none',
        color: 'inherit',
        transition: 'all var(--transition-base)',
        display: 'block'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-4px)';
        e.currentTarget.style.borderBottomColor = color;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.borderBottomColor = 'rgba(0, 16, 17, 0.1)';
      }}
    >
      <div style={{
        fontFamily: 'var(--font-sans)',
        fontSize: 'var(--text-sm)',
        color: 'var(--color-text-secondary)',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        marginBottom: 'var(--space-2)'
      }}>
        {title}
      </div>
      <div style={{
        fontFamily: 'var(--font-sans)',
        fontSize: 'clamp(2.5rem, 4vw, 4rem)',
        fontWeight: 700,
        color: color
      }}>
        {value}
      </div>
    </Link>
  );
}

function Card({ title, children }) {
  return (
    <div style={{
      padding: 'var(--space-6)',
      borderBottom: '1px solid rgba(0, 16, 17, 0.1)',
      backgroundColor: 'var(--color-bg-primary)'
    }}>
      <h3 style={{
        fontFamily: 'var(--font-sans)',
        fontSize: 'var(--text-xl)',
        fontWeight: 600,
        color: 'var(--color-text-primary)',
        marginBottom: 'var(--space-6)'
      }}>
        {title}
      </h3>
      {children}
    </div>
  );
}

function getStatusColor(status) {
  const colors = {
    overdue: 'var(--color-yellow-green)',
    warning: 'var(--color-yellow-green)',
    'due-soon': 'var(--color-frozen-lake)'
  };
  return colors[status] || 'var(--color-bg-secondary)';
}

const linkStyle = {
  padding: 'var(--space-3)',
  fontFamily: 'var(--font-sans)',
  fontSize: 'var(--text-base)',
  color: 'var(--color-text-primary)',
  textDecoration: 'none',
  borderBottom: '1px solid rgba(0, 16, 17, 0.1)',
  transition: 'all var(--transition-base)',
  display: 'block'
};

export default DashboardHome;

